import { render, staticRenderFns } from "./requestTraining.vue?vue&type=template&id=bda2a9f0&scoped=true&"
import script from "./requestTraining.vue?vue&type=script&lang=js&"
export * from "./requestTraining.vue?vue&type=script&lang=js&"
import style0 from "./requestTraining.vue?vue&type=style&index=0&id=bda2a9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda2a9f0",
  null
  
)

export default component.exports